/**
 * ACCourseSessionService
 * Service for managing course session templates (the per-course curriculum)
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for course session template CRUD operations
 */
export class ACCourseSessionService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ACCourseSessionService.DEFAULT_SERVICE_PATH,
            basePath: ACCourseSessionService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all session templates for a course
     * @param courseId - The course ID
     * @returns Array of course session templates
     */
    async byCourse(courseId) {
        const response = await this.byCourseRaw(courseId);
        return response.data ?? [];
    }
    /**
     * Get all session templates for a course with full response
     * @param courseId - The course ID
     * @returns ResponseData with array of course session templates
     */
    byCourseRaw(courseId) {
        const url = this.buildUrl(`by-course/${courseId}`);
        return this.http.get(url);
    }
}
ACCourseSessionService.DEFAULT_SERVICE_PATH = 'ac-courses';
ACCourseSessionService.BASE_PATH = 'api/course-sessions';
//# sourceMappingURL=ACCourseSessionService.js.map